import { Alert } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getTeamContactsMailing } from '@/services/teamAssignments.service';
import { useAuthStore } from '@/store/useAuthStore';
import { isHlbStaffRoles } from './companyListFilter';

/**
 * Where the recipients of a mailing come from, on the screen that sets that
 * mailing up: the client's confirmed contacts, or the list on this screen and why.
 * HLB staff only; a client on the same screen sees nothing of it.
 *
 * @param {Object} props
 * @param {string} props.companyId
 * @param {string} props.section - REPORTS, BOOKKEEPING, PAYMENTS or PAYROLL
 */
export default function RecipientSourceNote({ companyId, section }) {
  const { t } = useTranslation('teamContacts');
  const roles = useAuthStore((state) => state.user?.roles) || [];
  const { data } = useQuery({
    queryKey: ['team-contacts-mailing', companyId],
    queryFn: () => getTeamContactsMailing(companyId),
    enabled: !!companyId && isHlbStaffRoles(roles),
    retry: false,
    staleTime: 60 * 1000,
  });
  const row = data?.sections?.find((s) => s.section === section);
  if (!row) return null;
  if (row.source !== 'CONTACTS') {
    return (
      <Alert
        className="mb-3"
        type="info"
        showIcon
        message={t('source.noteLegacy')}
        description={t(`source.reason.${row.reason}`)}
      />
    );
  }
  return (
    <Alert
      className="mb-3"
      type="success"
      showIcon
      message={t('source.noteContacts')}
      description={
        <div className="[overflow-wrap:anywhere]">
          <div>{t('source.to', { list: row.to.join(', ') })}</div>
          {row.cc.length > 0 && <div>{t('source.cc', { list: row.cc.join(', ') })}</div>}
          {row.holder && row.relation !== 'OWN' && <div>{t(`source.relation.${row.relation}`, { name: row.holder.name })}</div>}
          {row.dropped.length > 0 && <div className="text-[#d46b08]">{t('source.dropped', { list: row.dropped.join(', ') })}</div>}
        </div>
      }
    />
  );
}
